import el from "@cypherpotato/el";
import dayjs from "dayjs";
import { formatDateTime } from "../ui/format";
import { MutedText } from "./text";

export function DateTimeLabel(time) {
    return el(".datetime-label",
        {
            title: formatDateTime(time)
        },
        dayjs(time).fromNow()
    )
}